import clsx from 'clsx'
import { AnimatePresence, type HTMLMotionProps, motion } from 'motion/react'
import { Fragment, type ReactNode } from 'react'
import styles from './EmptyPlaceholder.module.css'

export interface EmptyPlaceholderProps extends Omit<HTMLMotionProps<'div'>, 'title' | 'children'> {
	title?: ReactNode
	children?: ReactNode
}

export default function EmptyPlaceholder({
	title,
	children,
	className,
	...props
}: EmptyPlaceholderProps) {
	return (
		<motion.div
			initial={{
				opacity: 0,
			}}
			animate={{
				opacity: 1,
				transition: {
					delay: 0.5,
				},
			}}
			exit={{
				opacity: 0,
			}}
			className={clsx(styles.root, className)}
			{...props}
		>
			<AnimatePresence>
				{title &&
					(typeof title === 'string' ? (
						<motion.div key="empty-placeholder-title" className={styles.title}>
							{title}
						</motion.div>
					) : (
						title
					))}

				<Fragment key="empty-placeholder-content">{children}</Fragment>
			</AnimatePresence>
		</motion.div>
	)
}
